import { SET_CURRENT_LOCALE } from '../actionTypes';

export default function (state = 'en', action) {
  switch (action.type) {
    case SET_CURRENT_LOCALE:
      localStorage.setItem('ME3_PERSISTENCE_LOCALE', action.payload);
      return action.payload;
    default:
      return state;
  }
}
